import React, {useState} from 'react'
import {Button, Card, Image, Modal, Row, Space, Spin, Typography} from "antd";
import {useMount} from "ahooks";
import {VscsApi} from "../../services/VscsApi";
import SimpleTips from "../../containers/SimpleTips";
import {ExclamationCircleOutlined} from "@ant-design/icons";

const {confirm} = Modal;
const {Text} = Typography

const VscsPersonFrequencyPage = () => {
    const [hasMore, setHasMore] = useState(true)
    const [page, setPage] = useState(0)
    const [persons, setPersons] = useState([])
    const [loading, setLoading] = useState(false)

    const [mixMode, setMixMode] = useState(false);
    const [mixPersons, setMixPersons] = useState(new Set());

    const requestData = (page) => {
        setLoading(true)
        VscsApi.personFrequency(page)
            .onSuccess(data => {
                setPage(Number(data.left))
                setPersons([...persons, ...data.right])
                setHasMore(data.right.length > 0)
            })
            .onComplete(() => {
                setLoading(false)
            })
    }

    useMount(() => {
        requestData(0)
    })

    const handlePersonClick = (person) => {
        if (mixMode) {
            const _mixPerson = new Set([...mixPersons])
            if (_mixPerson.has(person)) {
                _mixPerson.delete(person)
            } else {
                _mixPerson.add(person)
            }
            setMixPersons(_mixPerson)
        } else {
            window.open('/#/vscs/person/faces?id=' + person.id)
        }
    }

    const handleNextPage = () => {
        requestData(page + 1)
    }

    const mapGender = (value) => {
        if (value === "-1") {
            return "未知"
        }
        if (value === "1") {
            return "女"
        }
        if (value === "0") {
            return "男"
        }
        return "/"
    }

    const getMixModeButtons = () => {
        if (!mixMode) {
            return <Button onClick={e => {
                e.preventDefault()
                setMixMode(true)
            }}>合并模式</Button>
        } else {
            return <Space>
                <span style={{color: '#95989a'}}>合并模式下，在页面中连续选择相同的人物来快速合并</span>
                <Button onClick={e => {
                    e.preventDefault()
                    setMixMode(false)
                    setMixPersons(new Set())
                }}>取消</Button>
                <Button type='primary' disabled={mixPersons.size <= 1} onClick={e => {
                    e.preventDefault()
                    const persons = [...mixPersons]
                    confirm({
                        title: '将要合并' + persons.length + '个人物',
                        icon: <ExclamationCircleOutlined/>,
                        content: <Space wrap={true}>
                            {
                                persons.map((person, index) => <>
                                    <Image
                                        height={80}
                                        width={80}
                                        style={{objectFit: 'cover'}}
                                        src={person.properties?.face.imageUrl}
                                    />
                                    {
                                        index === 0 && <Text>{`<-`}</Text>
                                    }
                                </>)
                            }
                        </Space>,
                        onOk() {
                            const ids = persons.map(person => person.id)
                            setLoading(true)
                            VscsApi.mixPersons(ids)
                                .onSuccess(() => {
                                    setMixMode(false)
                                    setMixPersons(new Set())
                                    window.location.reload()
                                })
                                .onComplete(() => {
                                    setLoading(false)
                                })
                        },
                        onCancel() {

                        },
                    });

                }}>保存</Button>
            </Space>
        }
    }

    return (
        <Spin spinning={loading}>
            <Card title={"当前人脸库"} extra={getMixModeButtons()}>
                <Space wrap>
                    {
                        persons.map(person =>
                            <Card size="small"
                                  onClick={() => handlePersonClick(person)}
                                  key={person.id}
                                  hoverable
                                  style={{width: 150}}
                                  bodyStyle={mixMode && mixPersons.has(person) ? {
                                      backgroundColor: '#94bfff',
                                  } : {}}
                                  cover={<Image
                                      height={150}
                                      preview={false}
                                      style={{objectFit: 'cover'}}
                                      src={person.properties?.face.imageUrl}
                                  />}>
                                <Space direction="vertical">
                                    <Text style={{fontSize: 13, margin: 0}}>#{person.id}</Text>
                                    <SimpleTips
                                        tips={[
                                            "A：" + person.age,
                                            "G：" + mapGender(person.gender)
                                        ]}
                                    />
                                </Space>
                            </Card>
                        )
                    }
                </Space>
                {
                    hasMore && <Row justify="center" style={{margin: 16}}>
                        <Button loading={loading} onClick={handleNextPage}>更多</Button>
                    </Row>
                }
                {
                    hasMore && <Row justify="center" style={{margin: 16}}>
                        <Text type="secondary"
                              style={{fontSize: 8}}>由于系统需要搜索全局过脸信息，为节约系统资源，每页仅返回最靠前的几条人脸数据。对于大量的人脸检索需要请多次点击此按钮。</Text>
                    </Row>
                }
            </Card>
        </Spin>
    )
}

export default VscsPersonFrequencyPage